// Styles
import '@shared/assets/style/animation.less';
import '@shared/assets/style/global.less';

// Components before viewless is better
import Ads from './elements/adsPlayer/adsSelector';
// import DebugConsole from './elements/debugConsole/debugConsole';
import FloatingMenu from './sections/floatingMenu/floatingMenu';
import Menu from './sections/menu/menu';
import Modal from '../utils/modals/modalManager';
import Network from './sections/network/network';
import Router from '../../shared/components/utils/router/router';
import Splash from './sections/splash/splash';
import Dial from './elements/dial/dial';

// Viewless after components is better
import Global from './utils/viewlessComponents/global';

/**
 * Main application component.
 * Renders all top-level components including router, menu, modals, floating menu, dial, ads, splash, network, and global viewless components.
 *
 * @returns {JSX.Element} The complete application structure
 */
export default function App() {
  return (
    <>
      {/* Visible components */}
      <Ads />
      <Router />
      <Menu />
      <Modal />
      <FloatingMenu />
      <Dial />
      <Splash />
      <Network />
      {/* <DebugConsole /> */}
      {/* Viewless components */}
      <Global />
    </>
  );
}
